/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Service Constants 

// UserAccountRoles
export const USER_ACCOUNT_ROLES_LANDLORD = 'landlord';
export const USER_ACCOUNT_ROLES_TENANT = 'tenant';
export const USER_ACCOUNT_ROLES_BROKER = 'broker';
export const USER_ACCOUNT_ROLES_MEDIATOR = 'mediator';
export const USER_ACCOUNT_ROLES_ADMIN = 'admin';
export const USER_ACCOUNT_ROLES_SUPER_ADMIN = 'super_admin';
export const USER_ACCOUNT_ROLES_SALES_DEMO = 'sales_demo';

// UserAccountState
export const USER_ACCOUNT_STATE_ACTIVE = 'active';
export const USER_ACCOUNT_STATE_BANNED = 'banned';
export const USER_ACCOUNT_STATE_AWAITING_FINALIZATION = 'awaiting_finalization';
export const USER_ACCOUNT_STATE_DEACTIVATED = 'deactivated';

// FundsLocationType
export const FUNDS_LOCATION_TYPE_BANK_ACCOUNT = 'bank_account';
export const FUNDS_LOCATION_TYPE_PAYMENT_STRIPE = 'payment_stripe';
export const FUNDS_LOCATION_TYPE_PAYMENT_YAPSTONE = 'payment_yapstone';
export const FUNDS_LOCATION_TYPE_PAYMENT_PRIORITY_ACH = 'payment_priority_ach';
export const FUNDS_LOCATION_TYPE_DEPOSIFY_LOAN = 'deposify_loan';
export const FUNDS_LOCATION_TYPE_USER_DEPOSITED_FUNDS_SEZZLE = 'user_deposited_funds_sezzle';

// InternalUserBankAccountType
export const INTERNAL_USER_BANK_ACCOUNT_TYPE_US_DOMESTIC = 'us_domestic';
export const INTERNAL_USER_BANK_ACCOUNT_TYPE_INTERNATIONAL = 'international';


